The partner's unique identifier for the position.

This identifier is used to track the position across sync operations.
